/* Hook for feed item note state. Opens a dialog for editing; persists via updateNote mutation. */

import { useState, useCallback } from "react";
import { useMutation } from "convex/react";
import { api } from "../../convex/_generated/api";
import type { Id } from "../../convex/_generated/dataModel";

export function useFeedItemNote(itemId: string, initialNote?: string) {
  const [isEditing, setIsEditing] = useState(false);
  const updateNote = useMutation(api.feedItems.updateNote);

  const hasNote = !!initialNote;
  const displayNote = initialNote ?? "";

  const startEditing = useCallback(() => {
    setIsEditing(true);
  }, []);

  const cancelEditing = useCallback(() => {
    setIsEditing(false);
  }, []);

  const saveNote = useCallback(async (note: string) => {
    const trimmed = note.trim();
    if (trimmed === (initialNote ?? "").trim()) {
      setIsEditing(false);
      return;
    }
    await updateNote({
      id: itemId as Id<"feedItems">,
      note: trimmed || undefined,
    });
    setIsEditing(false);
  }, [initialNote, updateNote, itemId]);

  return { isEditing, startEditing, cancelEditing, saveNote, hasNote, displayNote };
}
